package uk.co.nickthecoder.kyd.shapes

import uk.co.nickthecoder.kyd.util.Vector2

data class Triangle(val a: Vector2, val b: Vector2, val c: Vector2)
